<template>

  <div class="ob-content">
    <v-card>
      <asset-types-table
        :source="source"
        @change="loading = true"
        @ready="loading = false"
        @click="$router.push({ name: 'asset-types/id', params: { id: $event.id} })" />
    </v-card>

    <v-btn fab fixed bottom right color="primary" @click="create()">
      <v-icon>add</v-icon>
    </v-btn>
  </div>

</template>

<script>
import Loader from '../shared/loader'
import AssetTypesTable from './components/asset-types-table'
import ApiService from '../../services/api.service.es6'
import CreateAssetTypeDialog from './components/create-asset-type-dialog'

export default {
  data () {
    return {
      loading: true,
      source: args => ApiService.findAllPaginated('asset-types', null, args.sort, args.pagination)
    }
  },

  methods: {
    async create () {
      const assetType = await this.$dialog.showAndWait(CreateAssetTypeDialog)

      if (assetType) {
        const response = await this.$store.dispatch('updateItem', {modelName: 'asset-types', item: assetType})
        this.$router.push({ name: 'asset-types/id', params: { id: response.id } })
      }
    }
  },

  components: {
    Loader,
    AssetTypesTable
  }
}
</script>

<style scoped lang="scss">

</style>
